import Modal from 'app/components/Modal';
import Form from 'app/components/Form';

const PrintSizeForm = props => {
  const {
    isOpen,
    onClose,
    onSubmit,
    printSizes,
    selectedPrintSizes,
    isMobile
  } = props;

  let title = 'Manage Print Sizes';
  let action = 'update';

  let fields = printSizes.map(item => {
    let selected = selectedPrintSizes.filter(printSize => printSize.id === item.id);
    return {
      name: item.size,
      label: item.size,
      type: 'checkbox',
      valueType: 'boolean',
      value: selected.length > 0
    }
  });

  // align form modal to right of screen on desktop
  let modalStyle = {};
  if (!isMobile) {
    modalStyle.justifyContent = 'end';
    modalStyle.marginRight = '1.5rem';
  }

  return (
    <Modal {...{
      open: isOpen,
      onClose,
      title,
      modalStyle
    }}>
      <Form {...{
        fields,
        action,
        onClose,
        onSubmit
      }} />
    </Modal>
  )
}

export default PrintSizeForm;
